// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@guestsupply/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { ellipsis, xScreen } from "@guestsupply/XDL/Utilities";
import { userListUsersTableStyles } from "@insite/content-library/Widgets/UserList/UserListUsersTable";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

// XNG-Changes: GSS-731
userListUsersTableStyles.usernameCells = {
    css: css`
        font-weight: 400;
        min-width: 230px;
        a span {
            font-size: 13px;
        }
        /* username wraps when too long */
        span {
            white-space: normal;
        }
    `,
};

userListUsersTableStyles.nameCells = {
    css: css`
        font-weight: 400;
        ${TypographyStyle} {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: block;
        }
    `,
};
userListUsersTableStyles.roleCells = {
    css: css`
        ${TypographyStyle} {
            white-space: nowrap;
        }
    `,
};
// XNG-Changes: lastSignIn and Status cells arent typography components
// so they didnt take cellTypographyProps style
userListUsersTableStyles.lastSignInCells = {
    css: css`
        font-size: 13px;
    `,
};
userListUsersTableStyles.statusCells = {
    css: css`
        font-size: 13px;
    `,
};

userListUsersTableStyles.noResultsContainer = {
    ...dataTableStyles.noResultsContainer,
};

userListUsersTableStyles.noResultsText = {
    ...dataTableStyles.noResultsText,
};
